import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "dropdown" }
const _hoisted_2 = {
  key: 0,
  class: "item"
}
const _hoisted_3 = { class: "title" }
const _hoisted_4 = {
  key: 1,
  class: "placeholder"
}
const _hoisted_5 = { class: "item" }
const _hoisted_6 = { class: "title" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")
  const _component_Avatar = _resolveComponent("Avatar")
  const _component_Select = _resolveComponent("Select")
  const _component_Footnote = _resolveComponent("Footnote")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Select, {
      modelValue: _ctx.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.value) = $event)),
      class: _normalizeClass({small: $props.small}),
      invalid: !$options.valid,
      style: _normalizeStyle({minWidth: $props.minWidth}),
      unstyled: false,
      options: $props.items,
      "option-label": $props.optionLabel,
      "option-value": $props.optionValue,
      "data-key": $props.optionValue,
      placeholder: $props.placeholder,
      "append-to": "body",
      "overlay-class": {'dropdown-overlay': true, small: $props.small, invalid: !$options.valid}
    }, {
      value: _withCtx(() => [
        (!!$options.current)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              ($options.current.icon)
                ? (_openBlock(), _createBlock(_component_Icon, {
                    key: 0,
                    icon: $options.current.icon,
                    height: "1.4rem"
                  }, null, 8 /* PROPS */, ["icon"]))
                : ('avatar_id' in $options.current)
                  ? (_openBlock(), _createBlock(_component_Avatar, {
                      key: 1,
                      image_id: $options.current.avatar_id,
                      name: $options.current.title,
                      height: "1.6rem",
                      width: "1.6rem",
                      "font-size": "0.7rem"
                    }, null, 8 /* PROPS */, ["image_id", "name"]))
                  : _createCommentVNode("v-if", true),
              _createElementVNode("span", _hoisted_3, _toDisplayString($options.current.title), 1 /* TEXT */)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString($props.placeholder), 1 /* TEXT */))
      ]),
      option: _withCtx(({option}) => [
        _createElementVNode("div", _hoisted_5, [
          (option.icon)
            ? (_openBlock(), _createBlock(_component_Icon, {
                key: 0,
                icon: option.icon,
                height: "1.4rem"
              }, null, 8 /* PROPS */, ["icon"]))
            : ('avatar_id' in option)
              ? (_openBlock(), _createBlock(_component_Avatar, {
                  key: 1,
                  image_id: option.avatar_id,
                  name: option.title,
                  height: "1.6rem",
                  width: "1.6rem",
                  "font-size": "0.7rem"
                }, null, 8 /* PROPS */, ["image_id", "name"]))
              : _createCommentVNode("v-if", true),
          _createElementVNode("span", _hoisted_6, _toDisplayString(option.title), 1 /* TEXT */)
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue", "class", "invalid", "style", "options", "option-label", "option-value", "data-key", "placeholder", "overlay-class"]),
    ($props.footnote)
      ? (_openBlock(), _createBlock(_component_Footnote, {
          key: 0,
          type: $options.valid ? 'default' : 'error'
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString($options.valid ? $props.description : $props.errText), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["type"]))
      : _createCommentVNode("v-if", true)
  ]))
}